import code from 'assets/portfolio/image/Code.png'
import football from 'assets/portfolio/image/FootBall.png'
import netflix from 'assets/portfolio/image/Netflix.png'
import game from 'assets/portfolio/image/Game.png'
import book from 'assets/portfolio/image/Book.png'
import badminton from 'assets/portfolio/image/badminton.png'

const HobbiesData = [
  {
    img: code,
    content: 'coding',
    color: '#161B45'
  },
  {
    img: football,
    content: 'Playing Football',
    color: '#24AE60'
  },
  {
    img: netflix,
    content: 'chill Netflix',
    color: '#FF1E2E'
  },
  {
    img: game,
    content: 'Playing game',
    color: '#161B45'
  },
  {
    img: book,
    content: 'Reading book',
    color: '#F2994B'
  },
  {
    img: badminton,
    content: 'Playing badminton',
    color: '#2C84EC'
  }
]

export default HobbiesData
